export default (arr: any []) =>
  arr.reduce(
    (reduction, next) => next ? [ ...reduction, next ] : reduction,
    []
  )



// WEBPACK FOOTER //
// ./src/utils/cleanse.tsx